import VideoEmbed from '@app/components/VideoEmbed'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import './VideoModalButton.scss'

interface IVideoModalButtonProps {
  className?: string
  videoId: string
  title: string
  autoPlay?: boolean
}

interface IVideoModalButtonState {
  showVideoModal: boolean
}

export default class VideoModalButton extends React.PureComponent<IVideoModalButtonProps, IVideoModalButtonState> {
  constructor(props: IVideoModalButtonProps) {
    super(props)
    this.state = {
      showVideoModal: false,
    }
    bindFunctions(this)
  }

  public render() {
    return (
      <span>
        <a className={this.props.className} onClick={(e) => this._showVideoModal()} title={this.props.title}>
          <FontAwesomeIcon icon={['fal', 'video']} size='lg' fixedWidth />
          <Modal isOpen={this.state.showVideoModal} toggle={this._hideVideoModal} centered={true} size='xl'>
            <ModalHeader toggle={this._hideVideoModal}>{this.props.title}</ModalHeader>
            <ModalBody>
              <VideoEmbed className='video-embed-modal' videoId={this.props.videoId} title={this.props.title} autoPlay={this.props.autoPlay} />
            </ModalBody>
            <ModalFooter>
              <Button color='secondary' outline onClick={this._hideVideoModal}>
                <FontAwesomeIcon icon={['fal', 'times']} fixedWidth /> Close
              </Button>
            </ModalFooter>
          </Modal>
        </a>
      </span>
    )
  }

  private _showVideoModal() {
    this.setState({ showVideoModal: true })
  }

  private _hideVideoModal() {
    this.setState({ showVideoModal: false })
  }
}